// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"SignUpComponent_signUpContainer__32wA9","signInLinkContainer":"SignUpComponent_signInLinkContainer__2rNqU"};